<!-- Who and over what stretch -->
<div class="metrics-card p-3 p-md-4 mb-3">
  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between">

    <div class="d-flex align-items-center">
      <span class="badge-icon d-flex align-items-center justify-content-center me-3">
        <i class="bi bi-award"></i>
      </span>

      <div>
        <p class="fs-xsmall fw-800 color-brand-primary mb-0">{{'metrics.eyebrow'|translate|uppercase}}</p>
        <p class="fs-20 fw-800 color-gray-950 mb-0">
          {{coachName()}}<span *ngIf="coachName()"> · </span>{{'metrics.title'|translate}}
        </p>
        <p class="fs-small fw-400 color-gray-400 mb-0">
          {{'metrics.range_desc'|translate: {months: months, exam: examName(examKey)} }}
        </p>
      </div>
    </div>

    <div class="d-flex flex-wrap align-items-center gap-2 mt-3 mt-lg-0">
      <span class="gain-badge fs-xsmall fw-800"
            *ngIf="summary && summary.monthOverMonthGain !== null"
            [class.negative]="(summary.monthOverMonthGain ?? 0) < 0">
        <i class="bi me-1" [class.bi-graph-up-arrow]="(summary.monthOverMonthGain ?? 0) >= 0"
           [class.bi-graph-down-arrow]="(summary.monthOverMonthGain ?? 0) < 0"></i>
        {{'metrics.month_over_month'|translate: {gain: summary.monthOverMonthGain} }}
      </span>

      <div class="switch d-inline-flex">
        <a class="switch-option text-center fs-small fw-800 clickable px-3 py-1" *ngFor="let option of monthOptions"
           [class.active]="months === option" (click)="setMonths(option)">
          {{'metrics.month_option'|translate: {months: option} }}
        </a>
      </div>

      <div class="switch d-inline-flex">
        <a class="switch-option text-center fs-small fw-800 clickable px-3 py-1"
           [class.active]="examKey === examKeys.TYT" (click)="setExamKey(examKeys.TYT)">
          {{examName(examKeys.TYT)}}
        </a>
        <a class="switch-option text-center fs-small fw-800 clickable px-3 py-1"
           [class.active]="examKey === examKeys.AYT" (click)="setExamKey(examKeys.AYT)">
          {{examName(examKeys.AYT)}}
        </a>
      </div>
    </div>

  </div>
</div>

<!-- The four figures -->
<div class="row g-3 mb-3">
  <ng-container *ngIf="!summary">
    <div class="col-12 col-md-6 col-xl-3" *ngFor="let placeholder of [1, 2, 3, 4]">
      <ngx-skeleton-loader count="1" appearance="line" [theme]="{height: '112px', 'border-radius': '16px', margin: '0'}"/>
    </div>
  </ng-container>

  <ng-container *ngIf="summary">
    <div class="col-12 col-md-6 col-xl-3">
      <div class="metrics-card kpi-card p-3 p-md-4 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-graph-up-arrow color-brand-primary me-1"></i>{{'metrics.score_gain'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 color-gray-950 mb-0">
          {{summary.averageScoreGain === null ? '—' : (summary.averageScoreGain > 0 ? '+' : '') + summary.averageScoreGain}}
        </p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{'metrics.score_gain_desc'|translate}}</p>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-3">
      <div class="metrics-card kpi-card p-3 p-md-4 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-calendar2-check color-brand-primary me-1"></i>{{'metrics.plan_completion'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 color-gray-950 mb-0">
          {{summary.planCompletionPercent === null ? '—' : '%' + summary.planCompletionPercent}}
        </p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{'metrics.plan_completion_desc'|translate}}</p>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-3">
      <div class="metrics-card kpi-card p-3 p-md-4 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-camera-video color-brand-primary me-1"></i>{{'metrics.meetings'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 color-gray-950 mb-0">{{summary.completedMeetingCount}}</p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0">
          {{'metrics.meetings_desc'|translate: {count: summary.activeStudentCount} }}
        </p>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-3">
      <div class="metrics-card kpi-card p-3 p-md-4 h-100">
        <p class="fs-xsmall fw-800 color-gray-500 mb-2">
          <i class="bi bi-bullseye color-brand-primary me-1"></i>{{'metrics.goal_progress'|translate|uppercase}}
        </p>
        <p class="fs-24 fw-800 color-gray-950 mb-0">
          {{summary.goalProgressPercent === null ? '—' : '%' + summary.goalProgressPercent}}
        </p>
        <p class="fs-xsmall fw-400 color-gray-400 mb-0">{{'metrics.goal_progress_desc'|translate}}</p>
      </div>
    </div>
  </ng-container>
</div>

<!-- Monthly movement -->
<div class="row g-3 mb-3">
  <div class="col-12 col-xl-7">
    <div class="metrics-card p-3 p-md-4 h-100">
      <p class="fs-small fw-800 color-gray-500 mb-3">{{'metrics.monthly_net'|translate|uppercase}}</p>

      <ngx-skeleton-loader
        *ngIf="monthlyIsLoading && !monthly.length" count="1" appearance="line"
        [theme]="{height: '260px', 'border-radius': '12px', margin: '0'}"/>

      <div class="chart-host" #scoreChartHost></div>

      <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!monthlyIsLoading && !hasScoreSeries()">
        {{'metrics.no_score_data'|translate}}
      </p>
    </div>
  </div>

  <div class="col-12 col-xl-5">
    <div class="metrics-card p-3 p-md-4 h-100">
      <p class="fs-small fw-800 color-gray-500 mb-3">{{'metrics.monthly_meetings'|translate|uppercase}}</p>

      <ngx-skeleton-loader
        *ngIf="monthlyIsLoading && !monthly.length" count="1" appearance="line"
        [theme]="{height: '260px', 'border-radius': '12px', margin: '0'}"/>

      <div class="chart-host" #meetingChartHost></div>

      <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!monthlyIsLoading && !hasMeetingSeries()">
        {{'metrics.no_meeting_data'|translate}}
      </p>
    </div>
  </div>
</div>

<!-- Where each student stands, and what they say about the coaching -->
<div class="row g-3">
  <div class="col-12 col-xl-7">
    <div class="metrics-card p-3 p-md-4 h-100">
      <p class="fs-small fw-800 color-gray-500 mb-3">{{'metrics.student_progress'|translate|uppercase}}</p>

      <ngx-skeleton-loader
        *ngIf="studentsIsLoading && !students.length" count="4" appearance="line"
        [theme]="{height: '56px', 'border-radius': '12px', margin: '0 0 8px 0'}"/>

      <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!studentsIsLoading && !students.length">
        {{'metrics.no_student'|translate}}
      </p>

      <div class="progress-row mb-3" *ngFor="let row of students">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="d-flex align-items-center overflow-hidden">
            <coach-student-avatar
              class="me-2" size="xs" [name]="row.student.name" [levelKey]="row.level?.key"></coach-student-avatar>
            <p class="fs-small fw-800 color-gray-950 mb-0 text-truncate me-2">{{row.student.name}}</p>
            <p class="fs-xsmall fw-400 color-gray-400 mb-0 text-nowrap" *ngIf="row.goalScore">
              {{row.currentScore ?? '—'}} → {{'metrics.goal_short'|translate: {score: row.goalScore} }}
            </p>
            <p class="fs-xsmall fw-400 color-gray-400 mb-0 text-nowrap" *ngIf="!row.goalScore">
              {{'metrics.no_goal'|translate}}
            </p>
          </div>

          <p class="fs-small fw-800 color-gray-950 mb-0" *ngIf="row.progressPercent !== null">
            %{{row.progressPercent}}
          </p>
        </div>

        <div class="progress-track" [ngClass]="row.level?.key ? 'level-' + row.level?.key : ''">
          <div class="progress-value" [style.width.%]="row.progressPercent ?? 0"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-xl-5">
    <div class="metrics-card p-3 p-md-4 h-100">
      <p class="fs-small fw-800 color-gray-500 mb-3">{{'metrics.evaluations'|translate|uppercase}}</p>

      <ngx-skeleton-loader
        *ngIf="evaluationsIsLoading" count="1" appearance="line"
        [theme]="{height: '160px', 'border-radius': '12px', margin: '0'}"/>

      <ng-container *ngIf="!evaluationsIsLoading && evaluations">
        <p class="fs-small fw-400 color-gray-400 mb-0" *ngIf="!evaluations.count">
          {{'metrics.no_evaluation'|translate}}
        </p>

        <ng-container *ngIf="evaluations.count">
          <div class="d-flex align-items-end mb-1">
            <p class="fs-24 fw-800 color-gray-950 mb-0">{{evaluations.overall}}</p>
            <p class="fs-small fw-400 color-gray-400 mb-1 ms-1">/ 5</p>
          </div>
          <p class="fs-xsmall fw-400 color-gray-400 mb-3">
            {{'metrics.evaluation_count'|translate: {count: evaluations.count} }}
          </p>

          <div class="d-flex align-items-center justify-content-between py-2 evaluation-row">
            <span class="fs-small fw-500 color-gray-500">{{'metrics.evaluation_communication'|translate}}</span>
            <span class="fs-small fw-800 color-gray-950">{{evaluations.communication}}</span>
          </div>
          <div class="d-flex align-items-center justify-content-between py-2 evaluation-row">
            <span class="fs-small fw-500 color-gray-500">{{'metrics.evaluation_program_fit'|translate}}</span>
            <span class="fs-small fw-800 color-gray-950">{{evaluations.programFit}}</span>
          </div>
          <div class="d-flex align-items-center justify-content-between py-2">
            <span class="fs-small fw-500 color-gray-500">{{'metrics.evaluation_motivation'|translate}}</span>
            <span class="fs-small fw-800 color-gray-950">{{evaluations.motivation}}</span>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
